<script lang="ts" setup>
import { computed, defineAsyncComponent, onMounted, onUnmounted, ref } from 'vue'
import { lightSet } from '@/service/driver/light_set'
// import { setData } from '@/service/driver/data'
import { DialogType, enableDialog } from '../cdialog/dialog'
import i18n from '@/languages/i18n'
import LightConfigPanel from './LightConfigPanel.vue'
import { LightModeType } from '@/define/light'
import SvgAsset from '../common/SvgAsset.vue'
import actionLoadingSvg from '@/assets/inline-svg/action-loading.svg?raw'
import actionSuccessSvg from '@/assets/inline-svg/action-success.svg?raw'
// import { LightModeParam } from '@libs/types/response'
// import { KK } from '@/define/define'

// 懒加载组件
const LightModeTabs = defineAsyncComponent(() => import('./LightModeTabs.vue'))
const LightEffectList = defineAsyncComponent(() => import('./LightEffectList.vue'))
const LightColorPicker = defineAsyncComponent(() => import('./LightColorPicker.vue'))
const { t } = i18n.global

const cancelStatus = ref('idle')
const cancelColor = () => {
  enableDialog(t('cancel_light_effect'), DialogType.confirm).then((value: boolean) => {
    if (value) {
      cancelStatus.value = 'loading'
      const colorsCustom = lightSet.lightData.ColorsCustom
      for (const key in lightSet.lightData.ColorsCustom) {
        if (lightSet.currentModeTypeTab.value != LightModeType.Side) {
          delete colorsCustom[Number(key)]
        } else {
          colorsCustom[Number(key)] = 0
        }
      }
      lightSet.lightData = {
        ...lightSet.lightData,
        ColorsCustom: colorsCustom,
      }
      cancelStatus.value = 'success'
      setTimeout(() => {
        cancelStatus.value = 'idle'
      }, 1000)
    }
  })
}
// 解除自定义灯效的锁定
// const lightUnlock = (ms: number = 10) => setTimeout(() => (customUnlock = false), ms)

// const setKeysColor = async (newValue: { [index: KK]: number }, oldValue: { [index: KK]: number }) => {
//   if (customUnlock) {
//     clearSetCustomColorInterval()
//     return
//   }
//   customUnlock = true
//   try {
//     setData.getData().LightCustom = getColorKeys(newValue)
//     await setData.saveCustomColor()
//   } catch (error) {
//     setData.getData().LightCustom = oldValue
//   } finally {
//     lightUnlock()
//   }
// }
// const clearSetCustomColorInterval = () => {
//   if (setColorTimeout) {
//     clearTimeout(setColorTimeout)
//   }
//   setColorTimeout = setTimeout(() => {
//     setKeysColor(lightSet.lightData.ColorsCustom, lightSet.lightData.ColorsCustom)
//     if (setColorTimeout) {
//       clearTimeout(setColorTimeout)
//       setColorTimeout = null
//     }
//   }, 800)
// }
// // 自定义颜色的返回数据
// const getColorKeys = (newValue: { [index: KK]: number }) => {
//   const keys = []
//   for (const key in newValue) {
//     keys.push({ Key: Number(key), Value: newValue[Number(key)] })
//   }
//   return { Keys: keys, Light: setData.getData().LightMode.Light }
// }

// const flushPendingLightMode = () => {
//   if (!pendingLightMode) {
//     lightModeFlushTimer = null
//     return
//   }
//   pendingLightMode = null
//   lightModeFlushTimer = null
//   if (lightSet.currentModeTypeTab.value == LightModeType.Side) {
//     setData.saveLightDecoration()
//   } else {
//     if (lightSet.lightData.LightLastIsCustom == false) {
//       setData.saveLightMode()
//     } else {
//       setKeysColor(setData.getData().LightCustom, setData.getData().LightCustom)
//     }
//   }
// }
const computeDecorateCancel = computed(() => {
  return lightSet.currentModeTypeTab.value === LightModeType.Side && lightSet.modeName.includes('自定义')
})
onMounted(() => {
  lightSet.syncInitialLightData()
  lightSet.checkMusicRhythmAvailableStatus()
})
onUnmounted(() => {
  lightSet.clear()
})
// watch(
//   () => setData.getData().LightMode,
//   (value: LightModeParam) => {
//     console.log('保存灯光模式数据')
//     pendingLightMode = value
//     if (!lightModeFlushTimer) {
//       lightModeFlushTimer = setTimeout(flushPendingLightMode, 0)
//     }
//   },
//   { deep: true },
// )
// watch(
//   () => setData.getData().LightLastIsCustom,
//   (value: boolean) => {
//     console.log('自定义灯效切换')
//     if (value) {
//       setKeysColor(setData.getData().LightCustom, setData.getData().LightCustom)
//     }
//   },
// )
// watch(
//   () => setData.getData().LightCustom,
//   (oldValue, newValue) => {
//     console.log('保存自定义灯效数据')
//     if (setData.getData().LightLastIsCustom) {
//       setKeysColor(newValue, oldValue)
//     }
//   },
//   { deep: true },
// )
</script>

<template>
  <div class="light-container">
    <div class="light-container-main">
      <div class="content-container" v-if="lightSet.lightData && lightSet.lightData.LightMode">
        <div class="light-mode-container">
          <LightModeTabs />
          <LightEffectList />
        </div>
        <div v-if="lightSet.effectIsSelected(100) || computeDecorateCancel" class="mgx_action_btn primary close-color" :class="{ is_loading: cancelStatus === 'loading', is_success: cancelStatus === 'success' }" @click="cancelColor">
          <div class="btn-content-fade" :key="cancelStatus">
            <div class="icon-wrapper" v-if="cancelStatus === 'loading'">
              <SvgAsset :content="actionLoadingSvg" />
            </div>
            <div class="icon-wrapper" v-else-if="cancelStatus === 'success'">
              <SvgAsset :content="actionSuccessSvg" />
            </div>
            <span v-if="cancelStatus === 'idle'">{{ $t('cancel_color') }}</span>
            <span v-else-if="cancelStatus === 'loading'">{{ $t('canceling') }}</span>
            <span v-else-if="cancelStatus === 'success'">{{ $t('cancel_success') }}</span>
          </div>
        </div>
        <LightColorPicker />
        <LightConfigPanel />
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.light-container {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
  min-height: 0;
  border-radius: var(--radius-l);
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: transform 0.4s cubic-bezier(0.23, 1, 0.32, 1);
  margin-top: 0;
  outline: none;
  background: transparent; /* 为了让伪元素承担毛玻璃背景 */

  /* 核心修复：使用伪元素实现毛玻璃，解决 position: fixed 弹窗被截断/位移的问题 */
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: var(--glass-panel-bg);
    backdrop-filter: var(--glass-panel-blur);
    border-radius: inherit;
    z-index: -1;
    pointer-events: none; /* 确保不拦截交互 */
  }

  /* 移除会触发 Containing Block 的属性 */
  backface-visibility: visible;
  transform: none;
  background-clip: border-box;

  .close-color {
    position: absolute;
    right: 40px;
    bottom: 30px;
    z-index: 10;
  }

  .light-container-main {
    flex: 0 0 auto;
    width: 100%;
    min-width: 0;
    padding: 32px 40px;
    min-height: 0;
    display: flex;
    align-items: flex-start;
    box-sizing: border-box;

    .content-container {
      width: 100%;
      min-height: 0;
      display: flex;
      justify-content: flex-start;
      align-items: stretch;
      gap: 40px; /* 保持原始间距 */
      flex-wrap: nowrap; /* 保持并排布局 */

      @media @x-sm {
        gap: 20px; /* 窄屏缩小间距 */
      }
    }

    .light-mode-container {
      flex: 1 1 auto; /* 使其自适应剩余空间 */
      max-width: 576px; /* 锁定原本的 5 列宽度，防止大屏下图标拉成一行 */
      min-width: 0; /* 允许在窄屏下无限缩减 */
      display: flex;
      flex-direction: column;
      gap: 20px;
    }
  }
}

@media @y-md {
  .light-container {
    .close-color {
      right: 28px;
      bottom: 24px;
    }

    .light-container-main {
      padding: 24px 28px 82px;

      .content-container {
        gap: 24px;
      }

      .light-mode-container {
        gap: 16px;
      }
    }
  }
}

@media @y-sm {
  .light-container {
    margin-top: 0;

    .close-color {
      right: 20px;
      bottom: 18px;
    }

    .light-container-main {
      padding: 20px 22px 72px;

      .content-container {
        gap: 16px;
      }

      .light-mode-container {
        gap: 12px;
        max-width: none;
      }
    }
  }
}
</style>
